<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-10 header-margin">
        <!-- トークンデータエラー用設定 -->
        <div class="text-center p-2">
            <div v-if="this.title == 'changePassword'">
                <h3>{{ $t('auth.changePassword.timeOverTokenTitle') }}</h3>
            </div>
        </div>
        <div class="text-center p-2">
            <div class="show-check-email-message" v-if="this.message == 'userTokenDataWithin24H'" v-html="$t('auth.notLatestTokenText')"></div>
            <div v-if="this.message == 'notExistToken'">
                {{ $t('auth.notExistTokenText') }}
            </div>
            <div class="show-check-email-message" v-if="this.message == 'timeOverToken'" v-html="$t('auth.timeOverTokenText')"></div>
            <div class="show-check-email-message" v-if="this.message == 'notLatestToken'" v-html="$t('auth.notLatestTokenText')"></div>
        </div><br />
        <div class="text-center">
            <div class="pb-4 ">
                <a class="btn btn-primary text-center-btn" href="/" role="button">{{$t('auth.changeEmail.buttom') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'auth-error',
        created() {
            this.title = this.$route.query.title;
            this.message = this.$route.query.message;
        },
    }
</script>

<style scoped>
    .show-check-email-message {
        text-align: center;
    }
    .show-check-email-message >>> br {
        display: inline;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>
